module.exports = __webpack_public_path__ + "static/media/copy-alt.8a81c4ad.svg";